import {FC} from "react";
import {useSelector} from "react-redux";
import styled from "@emotion/styled";
import {Outlet} from "react-router-dom";
import {getIsShowSecretPage} from "modules/selectors";
import {SecretPage} from "components";
import bg from "assets/images/secretPageBg.png";

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	flex-grow: 1;
	position: relative;
	min-height: 100vh;
	background: url(${bg}) no-repeat center;
	background-color: #151515;
	background-size: cover;
`;

export const SecretKeyLayout: FC = () => {
	const isShowSecretPage = useSelector(getIsShowSecretPage);

	if (isShowSecretPage) {
		return (
			<Container>
				<SecretPage />
			</Container>
		);
	}

	return <Outlet />;
};
